import React, {useState} from "react";

import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Donate from "./components/sanjhauli/Donate";
import Home from "./components/sanjhauli/Home";
import Book_Place from "./components/sanjhauli/Book_Place";
import View_list from "./components/sanjhauli/View_list";
import About from "./components/sanjhauli/About";
import Work from "./components/sanjhauli/Work";
import Contact from "./components/sanjhauli/Contact";
import Admin from "./components/sanjhauli/Admin";
import Gallery from "./components/sanjhauli/Gallery";
import Navbarmenu from "./components/menu/Navbarmenu";
import Footer from "./components/sanjhauli/Footer";
import {NextGallery} from "./components/sanjhauli/NextGallery";
import {NextGallery1} from "./components/sanjhauli/NextGallery1";
import TowK24 from "./components/sanjhauli/Subpage/TowK24";
import TowK23 from "./components/sanjhauli/Subpage/TowK23";
import TowK22 from "./components/sanjhauli/Subpage/TowK22";
import Welcome from "./components/sanjhauli/Welcome";
import Adminpanel from "./components/sanjhauli/Admin_panel";
import Add from "./components/sanjhauli/Add";
import DonorsDetails from "./components/sanjhauli/Donors";
import Book_Place_Status from "./components/sanjhauli/Book_Place_Status";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const login = () => {
    setIsAuthenticated(true);
  };

  const logout = () => {
    setIsAuthenticated(false);
  };

  return (
    <>
      <div className="App">
        <Router basename="/">
          <Navbarmenu />
          <Routes>
            <Route exact path="/" element={<Home />} />

            <Route exact path="/sanjhauli/Donate" element={<Donate />} />
            <Route exact path="/book-place" element={<Book_Place />} />
            <Route exact path="/sanjhauli/View_list" element={<View_list />} />
            <Route exact path="/sanjhauli/About" element={<About />} />
            <Route exact path="/sanjhauli/Work" element={<Work />} />
            <Route exact path="/sanjhauli/Contact" element={<Contact />} />
            <Route exact path="/sanjhauli/Admin" element={<Admin />} />
            <Route exact path="/sanjhauli/Gallery" element={<Gallery />} />
            <Route exact path="/NextGallery" element={<NextGallery />} />
            <Route exact path="/NextGallery1" element={<NextGallery1 />} />
            <Route exact path="/Welcome" element={<Welcome />} />
            <Route exact path="/TowK24" element={<TowK24 />} />
            <Route exact path="/TowK23" element={<TowK23 />} />
            <Route exact path="/TowK22" element={<TowK22 />} />
            <Route exact path="/admin-panel" element={<Adminpanel />} />
            <Route exact path="/add-donor" element={<Add />} />
            <Route exact path="/donors-details" element={<DonorsDetails />} />
            <Route
              exact
              path="/reserve-place"
              element={<Book_Place_Status />}
            />
            <Route
              path="/book-place"
              element={
                <Book_Place logout={logout} />
              }
            />
          </Routes>
          <Footer />
        </Router>
      </div>
    </>
  );
}
export default App;
